<template>
  <el-dialog title="确认审批" :visible.sync="visible" width="30%">
    <p class="tips">请确认线下审批已完成？</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { changeStatus } from "@/api/crm/contract";

export default {
  name: "ConfirmCheck",
  props: {
  },
  data() {
    return {
      visible: false,
      data: {
        contractId: null,
        operateType: 1
      }
    };
  },
  methods: {
    options (id) {
      if (!id) {
        this.msgError("当前合同id异常")
        return
      }
      this.data.contractId = id
      this.visible = true
    },
    confirm () {
        const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
        });
        changeStatus(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("线下审批确认成功");
        }).catch(error => {
            loading.close()
        })
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
    font-size: 16px;
}
</style>